import {
  Box,
  BoxProps,
  Stack,
  useColorModeValue,
  useDisclosure,
} from '@cardboard-ui/react';
import PrivateNote from 'apps/TenantApp/components/PrivateNote';
import React from 'react';
import { Layout, useActiveLayout } from 'utils/LayoutProvider';
import { useFeatureFlag } from 'utils/sessionProvider';
import ItemInfo from '../../components/ItemInfo';
import { CollapseButton } from './components/CollapseButton';

interface ItemSidebarProps {
  nodeId: string;
}

export const ItemSidebar: React.FC<ItemSidebarProps> = ({ nodeId }) => {
  const isFeatureItemInfoEnabled = useFeatureFlag('FEATURE_ITEM_INFO');
  const isMobile = useActiveLayout() !== Layout.DESKTOP;
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: !isMobile });
  const MENU_WIDTH = isMobile ? '90vw' : 96;
  const bg = useColorModeValue('white', 'gray.800');

  const styles: BoxProps = isMobile
    ? {
        pos: 'absolute',
        h: '100%',
        boxShadow: 'lg',
        right: 0,
        overflow: 'hidden',
      }
    : {};

  return (
    <>
      <CollapseButton onToggle={onToggle} isOpen={isOpen} width={MENU_WIDTH} />

      <Box
        w={isOpen ? MENU_WIDTH : '0px'}
        transition=".3s all"
        bg={bg}
        {...styles}
      >
        <Stack p={3}>
          {isFeatureItemInfoEnabled && <ItemInfo nodeId={nodeId} />}

          <PrivateNote nodeId={nodeId} />
        </Stack>
      </Box>
    </>
  );
};
